"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffMemberEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const StaffMemberDto_1 = require("./StaffMemberDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const LocationEntity_1 = require("../locations/LocationEntity");
const LocationDto_1 = require("../locations/LocationDto");
class StaffMemberEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, staffMember) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            department: false,
            firstName: false,
            lastName: false,
            title: false,
            order: false
        };
        this._dependencies = dependencies;
        if (staffMember === undefined) {
            this._dto = new StaffMemberDto_1.StaffMemberDto();
        }
        else if (staffMember instanceof StaffMemberDto_1.StaffMemberDto) {
            this._dto = new StaffMemberDto_1.StaffMemberDto(staffMember);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else if (staffMember instanceof StaffMemberEntity) {
            this._dto = new StaffMemberDto_1.StaffMemberDto(staffMember._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new StaffMemberDto_1.StaffMemberDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getImageId() {
        return this._dto.imageId;
    }
    getImagePath() {
        return this._dto.imagePath;
    }
    setImageId(untrustedValue) {
        let _untrustedValue;
        this.clearError("imageId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("imageId", "Image Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.imageId) {
            return;
        }
        this._dto.imageId = _untrustedValue;
        this._setIsDirty(true);
    }
    getDepartment() {
        return this._dto.department;
    }
    setDepartment(untrustedValue) {
        const maxLength = 50;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("department");
        this._requiredFieldsSetStatus.department = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("department", "Department is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("department", `Department has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.department) {
            return;
        }
        this._dto.department = _untrustedValue;
        this._setIsDirty(true);
    }
    getFirstName() {
        return this._dto.firstName;
    }
    setFirstName(untrustedValue) {
        const maxLength = 40;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("firstName");
        this._requiredFieldsSetStatus.firstName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("firstName", "First Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("firstName", `First Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.firstName) {
            return;
        }
        this._dto.firstName = _untrustedValue;
        this._setIsDirty(true);
    }
    getLastName() {
        return this._dto.lastName;
    }
    setLastName(untrustedValue) {
        const maxLength = 40;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("lastName");
        this._requiredFieldsSetStatus.lastName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("lastName", "Last Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("lastName", `Last Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.lastName) {
            return;
        }
        this._dto.lastName = _untrustedValue;
        this._setIsDirty(true);
    }
    getTitle() {
        return this._dto.title;
    }
    setTitle(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("title");
        this._requiredFieldsSetStatus.title = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("title", "Title is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("title", `Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.title) {
            return;
        }
        this._dto.title = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmail() {
        return this._dto.email;
    }
    setEmail(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("email");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("email", `Email has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.email) {
            return;
        }
        this._dto.email = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhone() {
        return this._dto.phone;
    }
    setPhone(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phone");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phone", `Phone has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.phone) {
            return;
        }
        this._dto.phone = _untrustedValue;
        this._setIsDirty(true);
    }
    getTextMessageNumber() {
        return this._dto.textMessageNumber;
    }
    setTextMessageNumber(untrustedValue) {
        const maxLength = 15;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("textMessageNumber");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("textMessageNumber", `Text Message Number has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.textMessageNumber) {
            return;
        }
        this._dto.textMessageNumber = _untrustedValue;
        this._setIsDirty(true);
    }
    getOrder() {
        return this._dto.order;
    }
    setOrder(untrustedValue) {
        let _untrustedValue;
        this.clearError("order");
        this._requiredFieldsSetStatus.order = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 0 })) {
            this.addError(new ValidationError_1.ValidationError("order", "Order is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("order", "Order is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.order) {
            return;
        }
        this._dto.order = _untrustedValue;
        this._setIsDirty(true);
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.staffMemberDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Staff Member is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.staffMemberDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.staffMemberDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (this.getId() !== undefined) {
                    yield this._dependencies.staffMemberDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.StaffMemberEntity = StaffMemberEntity;
//# sourceMappingURL=StaffMemberEntity.js.map